import React from 'react';
import PropTypes from 'prop-types';
import { Text, View } from 'react-native';
import { t } from 'Locale';

import Icon from '../../../Icon';

import defaultStyles from './LockedContent.jss';

const LockedContent = ({ style, dimension, adult }) => (
    <View style={[defaultStyles.itemImageContainer, dimension, style]}>
        <View style={defaultStyles.textWrapper}>
            <Text style={defaultStyles.lockedContent}>
                {adult ? t('COMMON.LOCKED_ADULT_CONTENT') : t('COMMON.LOCKED_CONTENT')}
            </Text>
        </View>
        <Icon name="lock" />
    </View>
);

LockedContent.defaultProps = {
    style: {},
    adult: false
};

LockedContent.propTypes = {
    style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    dimension: PropTypes.shape({
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        height: PropTypes.number.isRequired
    }).isRequired,
    adult: PropTypes.bool
};

export { LockedContent };
